module.exports = __webpack_public_path__ + "static/media/storePreviewDefault.12ab0917.svg";